import { FormSection, SectionHeader, ToggleWithDescription } from '../base';
import { UseFormReturn } from 'react-hook-form';
interface ConsentModeSectionProps {
  form: UseFormReturn<any>;
}

export const ConsentModeSection = ({ form }: ConsentModeSectionProps) => {
  return (
    <FormSection>
      <SectionHeader>Enable Consent Mode</SectionHeader>
      <ToggleWithDescription form={form} name="consentMode">
        When enabled, consent mode will require users to opt-in to data sharing before transactions
        are sent. By default, consent mode is disabled.
      </ToggleWithDescription>
    </FormSection>
  );
};
